import { createAsyncThunk } from '@reduxjs/toolkit';

import { entitiesActions } from '../slices/entitiesSlice';
import type { RootState } from '../store';

import { groupsService } from './_deps';

export const confirmGroup = createAsyncThunk<void, string, { state: RootState }>(
  'groups/confirm',
  async (groupId, thunkApi) => {
    const { dispatch, getState } = thunkApi;

    const updatedGroup = await groupsService.confirmGroup({
      groupId,
    });

    dispatch(entitiesActions.upsertGroup(updatedGroup));
  },
);
